import axios from "axios";
import React, { useEffect, useState } from "react";

export const useGetGoldebBallInfo = ({phase})=>{
    const idGoldenBallEdition =  window.location.pathname?.split('/')?.[3]
    const [isLoading, setIsLoading] = useState(false)
    const [goldenBallInfo, setGoldenBallInfo] = useState('')
    console.log({idGoldenBallEdition})
    const urlMapGoldenBallEdition = {
        "nominates": `https://web-production-58ed.up.railway.app/api/get/onlyEditionGoldenball`,
        "eleven": 'https://web-production-58ed.up.railway.app/api//get/goldenBallEdition',
    }

    useEffect(()=>{
        if(!idGoldenBallEdition) return
        const url = urlMapGoldenBallEdition?.[phase]
        setIsLoading(true)
        axios.get(url,{params:{
            id: idGoldenBallEdition
        }}).then(res =>{
            console.log('res', res)
            setGoldenBallInfo(res?.data?.goldenBall)
            setIsLoading(false)
        } ).catch(e=> {
            console.log('e', e)
            setIsLoading(false)
        })

    },[idGoldenBallEdition])

    return{
        goldenBallInfo,
        isLoading
    }
}